import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import axios from '../../axios/request'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import router from './router'
import '@babel/polyfill'
import vueJsonp from 'vue-jsonp'
import login from "@/views/login/Login.vue"

Vue.prototype.$axios = axios

Vue.use(ElementUI)
Vue.use(vueJsonp)
Vue.use(BootstrapVue)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(login)
}).$mount('#login')
